import { createStyles } from "antd-style";
const useStyles = createStyles(({ css, token, prefixCls }, props) => ({
  loginWrapper: css`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  logo: css`
    height: 48px;
    margin: 20px;
  `,
  left: css`
    width: 65%;
    height: 100%;
    background-color: #b7c9d9;
    ${(props == null ? void 0 : props.backgroundImage) && `background-image: url("${props.backgroundImage}");`}
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  `,
  right: css`
    width: calc(100% - 65%);
    height: 100%;
  `,
  rightSpin: css`
    height: 100%;
    .${prefixCls}-spin-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
  `,
  rightHeader: css`
    margin: 12px 24px;
    display: flex;
    align-self: end;
  `,
  rightFooter: css`
    margin: 12px 24px;
  `,
  rightContent: css`
    width: 340px;
    margin-bottom: 72px;
    .${prefixCls}-tabs-tab {
      font-size: 20px;
    }
  `,
  appName: css`
    font-weight: 500;
    font-size: 48px;
    color: ${token.colorText};
    margin-bottom: 32px;
    text-align: center;
  `,
  forgotPassword: css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
  `
}));
var style_default = useStyles;
export {
  style_default as default
};
